import { ReactNode } from 'react';

import { UserPermissions } from 'types';

import { useAuth } from './authProvider';

export const isAdminUser = (claims: any) => claims?.permissions?.includes(UserPermissions.admin);

export const RequireAdminUser = ({ children }: { children: ReactNode }) => {
  const { claims } = useAuth();
  const isAdmin = claims?.permissions?.includes(UserPermissions.admin);
  return isAdmin ? <>{children}</> : null;
};
